import fallbackObservation from "../data/weather/fallbackObservation.json";
import sampleHistory from "../data/weather/sampleHistory.json";
import { plotDefinitions } from "../data/weather/plotDefinitions";

const WEATHER_STATUS_MESSAGE = "Weather station unavailable. Showing previously recorded data.";

function buildHistoricalSeries(observationsByDay) {
  return plotDefinitions.reduce((accumulator, plot) => {
    accumulator[plot.value] = plot.series.map((series) => ({
      ...series,
      data: observationsByDay.map((observation) => observation?.metric?.[series.key] ?? null),
    }));
    return accumulator;
  }, {});
}

export async function loadDashboardData() {
  const historicalDates = sampleHistory.dates;
  const observationsByDay = sampleHistory.rows.map((row) => row.observation ?? null);
  const latestHistoricalObservation = [...observationsByDay].reverse().find(Boolean) ?? fallbackObservation;

  return {
    weatherData: latestHistoricalObservation.metric,
    stationInfo: latestHistoricalObservation,
    historicalSeries: buildHistoricalSeries(observationsByDay),
    historicalDates,
    weatherStatusMessage: WEATHER_STATUS_MESSAGE,
  };
}
